import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-dgymnastics',
  templateUrl: './program-dgymnastics.component.html',
  styleUrls: ['./program-dgymnastics.component.scss']
})
export class ProgramDgymnasticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
